<!--
 * @Description: 新增人员-执业信息面板组件
 * @Author: wanqian
 * @Date: 2022-03-28 11:23:40
 * @LastEditTime: 2023-11-27 13:28:10
-->
<template>
  <div class="attendant-practice-info-body">
		<el-form class="practiceInfoForm" ref="practiceInfoForm" :model="practiceInfoForm.attendant" :rules="rules" 
			label-position="top" label-width="100px">
      <el-row style="margin: 0 5px" :gutter="50" type="flex" justify="space-between">
				<el-col :span="8" style="text-align: left">
					<el-form-item label="执业开始时间：" prop="practiceStartDate">
						<el-date-picker style="width: 100%" class="date-picker-practiceStartDate" size="small" 
							v-model="practiceInfoForm.attendant.practiceStartDate" type="date" align="right" 
							placeholder="请选择执业开始时间" :clearable="false" :readonly="readonly" format = 'yyyy-MM-dd' 
							value-format = 'yyyy-MM-dd' :picker-options="pickerOptions"	@change="handleChangeDate">
      			</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="8" style="text-align: left">
					<el-form-item label="执业年限（年）：" prop="attendantAge">
						<el-input size="small" style="width: 100%" placeholder="请输入执业年限" clearable 
							v-model.trim="practiceInfoForm.attendant.attendantAge" :readonly="true">
						</el-input>
					</el-form-item>
				</el-col>
				<el-col :span="8" style="text-align: left">
					<el-form-item label="护理员等级：" prop="level">
						<el-select v-if="readonly" size="small" style="width: 100%" v-model="practiceInfoForm.attendant.levelText" 
							:disabled="readonly">
						</el-select>
						<el-select v-else-if="!readonly && levelList" size="small" style="width: 100%" :disabled="readonly"
							v-model="practiceInfoForm.attendant.level" filterable placeholder="请选择护理员等级">
							<el-option v-for="(item, index) in levelList" :key="index" :label="item.value" 
								:value="parseInt(item.key)" :disabled="item.disabled">
							</el-option>
						</el-select>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
		<div class="bk-wizard-bottons" style="padding-right: 25px;">
			<wizard-buttons :mode="mode" :status="btnStatus" @btnpressed="handleBtnSelection" />
		</div>
  </div>
</template>

<script>
import attendantStore from './AttendantStore.js'

let AttendantPracticeInfoPanel = {
  name: 'AttendantPracticeInfoPanel',
  attendantStore,
  
  data() {
		let validateAttendantAge = (_rule, _value, callback) => {
			let attendantAge = this.dateUtil.calcDifference(this.practiceInfoForm.attendant.practiceStartDate, new Date());
			attendantAge = attendantAge < 1 ? attendantAge : Math.floor(attendantAge);
			if (!this.practiceInfoForm.attendant.practiceStartDate) {
				callback(new Error('请选择执业开始时间'));
			} else if (attendantAge > this.practiceInfoForm.attendant.age - 18) {
				callback(new Error('执业年限 <= 年龄-18'));
			} else {
				callback();
			}
    };

    return {
      btnStatus: {'prev': true, 'next': true, 'submit': false},
			pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: this.dateUtil.datePickerOptions.shortcuts
      },
      rules: {
				practiceStartDate: [{required: true, message: '请选择执业开始时间', trigger: 'blur'},],
				attendantAge: [{required: true, validator: validateAttendantAge, trigger: 'blur'},],
				level: [{required: true, message: '请选择护理员等级', trigger: 'blur'},],
      },
      // 过滤查询相关变量 
      dateRangePickerOptions: this.dateUtil.getDateRangePickerOptions(true, false)
    }
  },
  
  computed: {
    mode() {
      return attendantStore.state.mode;
    },

    practiceInfoForm() {
      return attendantStore.state.attendantDo;
    },

		levelList() {
			let result = [];
			if (!attendantStore.state.attendantDo.hasOwnProperty('levelMap') || !attendantStore.state.attendantDo.levelMap) {
				return result;
			}
			let attendantDo = attendantStore.state.attendantDo;
			let levelMap = attendantDo.levelMap;
			let obj;
			for (const i in levelMap) {
				if (i != 0) {
					result.push({'key': i, 'value': levelMap[i], 'disabled': false});
				} else {
					obj = {'key': i, 'value': levelMap[i], 'disabled': true};
				}
			}
			result.unshift(obj);
			return result;
		},

    readonly() {
      return attendantStore.state.mode == 'details';
    }
  },

	methods: {
		handleChangeDate(value) {
			this.practiceInfoForm.attendant.attendantAge = this.dateUtil.yearsAgoText(value, new Date());
		},

		handleBtnSelection(operate) {
      if (this.mode == 'details' || operate != 'next')  {
        this.$emit("panel-operate", operate);
        return true;
      }

      this.$refs.practiceInfoForm.validate((valid) => {
        if (!valid) return false;
				this.$emit("panel-operate", operate);
				return true;
      });
    },
	},
  
  destroyed() {
    //销毁的时候同步数据
    attendantStore.commit('changeAttendantDo', this.practiceInfoForm);
  },
}
export default AttendantPracticeInfoPanel
</script>

<style scope>
.attendant-practice-info-body {
	margin: 30px 0;
}
.practiceInfoForm {
	margin-bottom: 80px;
}
</style>
<style>
.attendant-practice-info-body .el-form-item {
	margin-bottom: 20px;
}
.attendant-practice-info-body .el-form--label-top .el-form-item__label {
	padding: 0px;
	line-height: 26px;
}

/* 日期图标右移 */
.attendant-practice-info-body .date-picker-practiceStartDate .el-input__prefix {
  left: initial;
  right: 5px;
}
.attendant-practice-info-body .date-picker-practiceStartDate .el-input__inner {
  padding-left: 17px;
}
</style>


// WEBPACK FOOTER //
// src/components/instmng/components/attendantdetails/AttendantPracticeInfoPanel.vue